import { DomainError } from '../errors/domain-error';

export const COMMUNITY_COMMENT_MAX_REPLY_DEPTH_DEFAULT = 3;
export const COMMUNITY_COMMENT_MAX_REPLY_DEPTH_MIN = 0;
export const COMMUNITY_COMMENT_MAX_REPLY_DEPTH_MAX = 10;

export type CommentDepthRow = {
  id: string;
  parentCommentId?: string | null;
};

export function normalizeCommunityCommentMaxReplyDepth(value?: number | null): number {
  if (value == null) return COMMUNITY_COMMENT_MAX_REPLY_DEPTH_DEFAULT;
  return Math.min(
    Math.max(value, COMMUNITY_COMMENT_MAX_REPLY_DEPTH_MIN),
    COMMUNITY_COMMENT_MAX_REPLY_DEPTH_MAX,
  );
}

export function computeCommentDepthMap(rows: CommentDepthRow[]): Map<string, number> {
  const byId = new Map(rows.map((row) => [row.id, row]));
  const depths = new Map<string, number>();

  function resolveDepth(id: string): number {
    const cached = depths.get(id);
    if (cached != null) return cached;

    const row = byId.get(id);
    if (!row?.parentCommentId || !byId.has(row.parentCommentId)) {
      depths.set(id, 0);
      return 0;
    }

    const depth = resolveDepth(row.parentCommentId) + 1;
    depths.set(id, depth);
    return depth;
  }

  for (const row of rows) {
    resolveDepth(row.id);
  }

  return depths;
}

export function assertCommunityCommentReplyDepth(params: {
  parentDepth: number | null;
  maxReplyDepth: number;
}): void {
  const nextDepth = (params.parentDepth ?? -1) + 1;
  if (nextDepth > params.maxReplyDepth) {
    throw new DomainError(
      `Reply depth limit reached for this community (max ${params.maxReplyDepth})`,
    );
  }
}
